/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorTrendingMenu as ResolvedLabradorTrendingMenu } from 'base/components/labrador/TrendingMenu';

export const LabradorTrendingMenu: typeof ResolvedLabradorTrendingMenu = withLabradorInstanceof((props) => {
    return <ResolvedLabradorTrendingMenu {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorTrendingMenuProps = PropsFromComponent<typeof LabradorTrendingMenu>;
